/**
* 机构- 销课记录
*/
<template>
  <div>
    <van-nav-bar placeholder title="销课记录" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
      </template>
    </van-nav-bar>
  <!--  &lt;!&ndash;搜索&ndash;&gt;
    <div>
      <van-search
              v-model="queryParams.name"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>-->
    <!--  销课记录别表数据-->
    <van-pull-refresh v-model="signData.topLoading" @refresh="refreshSign()">
      <van-list
              class="my-list"
              v-model="signData.bottomLoading"
              :finished="!signData.hasMore"
              finished-text="没有更多了"
              @load="onLoadSign"
      >
        <div class="mykc-box" v-for="(item,index) in signData.records" :key="index">
          <div class="jg-list-top" @click="goToPage(item, 1)">
            <img :src="fileDisplayPrefix + (item.pic ? item.pic.split(',')[0] : '')"/>
            <div class="jg-right">
              <h2><b>{{item.curriculumName}}</b></h2>
              <span>学生: {{item.studentName}}</span>
              <span>销课时间: {{item.signTime}}</span>
              <span>
                教师: {{item.teacherName}}
                <i v-if="item.status==='0'" class="t0">{{filterLabelName(signStatusOption,item.status)}}</i>
                <i v-else-if="item.status==='1'" class="t1">{{filterLabelName(signStatusOption,item.status)}}</i>
                <i v-else-if="item.status==='2'" class="t2">{{filterLabelName(signStatusOption,item.status)}}</i>
                <i v-else-if="item.status==='3'" class="t3">{{filterLabelName(signStatusOption,item.status)}}</i>
                <i v-else class="t4">{{filterLabelName(signStatusOption,item.status)}}</i>
              </span>
            </div>
          </div>
          <div class="jg-bottom"  style="justify-content: center">
            <van-button v-if="item.status === '0'" class="t0 jg-but" type="primary" size="mini"  @click="goToPage(item, 2)">修改</van-button>
          </div>
        </div >
      </van-list>
    </van-pull-refresh>

  </div>
</template>

<script>

  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {filterLabelName, getDictByType} from '@/api/common'
  import {signDataList} from '@/api/course/institutionCourse'
  import {handlePageData} from '@/utils/common'
  import Utils from "@/js/common/utils";
  import moment from 'moment'

  export default {
    name: 'InstitutionCourse',
    components: {
    },
    data () {
      return {
        moment,
        filterLabelName,
        show: false,
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        queryParams: {},
        signData: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
        identityInfo: {},
        signStatusOption: []
      }
    },
    computed: {
    },
    created () {
      this.getDict();
      const data = Utils.getLocal('identity') || '';
      this.identityInfo = JSON.parse(data);
      this.refreshSign()
    },
    mounted () {
    },
    methods: {
      onSearch() {
        this.refreshSign()
      },
      // 加载销课记录数据
      onLoadSign() {
        if (this.signData.current > 1 && this.signData.hasMore) {
          this.getSignDataList()
        }
      },
      // 获取销课记录列表数据
      getSignDataList () {
        if (this.signData.loading) return;
        this.signData.loading = true;
        this.queryParams.identity = this.identityInfo.value;
        this.queryParams.current = this.signData.current;
        this.queryParams.size = this.signData.size;
        signDataList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.signData, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.signData.loading = false;
            this.signData.topLoading = false;
            this.signData.bottomLoading = false
          }, 100)
        })
      },
      // 数据字典
      getDict() {
        // 查询字典，销课状态
        getDictByType('sign_status').then(res => {
          if (res.code === 10000) {
            this.signStatusOption = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      // 销课记录刷新
      refreshSign () {
        this.resetSign();
        this.getSignDataList();
      },
      resetSign() {
        this.signData.current = 1;
        this.signData.total = 0;
        this.signData.hasMore = true
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      //详情页面跳转 type: 1-详情页面 2-添加页面
      goToPage(item, type){
        switch (type) {
          case 1:
            //详情页面
            this.$router.push({path: `/institutionCourse/signDetail?signId=${item.signId}&signDetailId=${item.signDetailId}`});
            break;
          case 2:
            //修改
            this.$router.push({path: `/institutionCourse/signModify?signId=${item.signId}&signDetailId=${item.signDetailId}`});
            break;
          default:
        }
      }
    }
  }
</script>

<style scoped>
.my-list{
  background: #ffffff;
  padding:10px;
}
.mykc-box{
  /*height:108px;*/
  background: #F4F5F7;
  border-radius:12px;
  margin-bottom: 10px;
}
.jg-right span{
  width: 100%;
  justify-content: space-between;
}
.jg-right span i{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  padding:4px 6px;
  border-radius:12px;
  position: absolute;
  top: -5px;
  right: 0;
}
.jg-right span i.t0{
  background: #FF9900;
}
.jg-right span i.t1{
  background: #66C779;
}
.jg-right span i.t2{
  background: #66C779;
}
.jg-right span i.t3{
  background: #A37FFF;
}
.jg-right span i.t4{
  background: #A7A7A7;
}
.jg-right span i.t5{
  background: #A7A7A7;
}
.jg-bottom{
  padding-bottom: 10px;
}
.jg-bottom i.jg-but{
  margin-bottom: 10px;
}
</style>
